module.exports = __webpack_public_path__ + "static/media/target-with-arrow.b961f809.svg";